import { useAppSelector } from 'redux/store';

export default function useCurrentSuggester() {
  return useAppSelector((state) => state.suggester);
}
